import React from 'react'
import { Select, type SelectProps } from '@mantine/core'

export type AppSelectProps = SelectProps

/** Standard select with consistent sizing and radius. */
export default function AppSelect ({ size = 'sm', ...props }: AppSelectProps) {
  return <Select radius="sm" size={size} {...props} />
}
